import { render, staticRenderFns } from "./cooperationJoin.vue?vue&type=template&id=385cf142&scoped=true&"
import script from "./cooperationJoin.vue?vue&type=script&lang=js&"
export * from "./cooperationJoin.vue?vue&type=script&lang=js&"
import style0 from "./cooperationJoin.vue?vue&type=style&index=0&id=385cf142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385cf142",
  null
  
)

export default component.exports